(() => {
  const escapeHtml = (value = '') => String(value).replace(/[&<>'"]/g, (char) => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[char]));
  const normalize = (value = '') => String(value).trim().toLowerCase();
  const isAccessory = (product) => {
    const haystack = `${product.type || ''} ${product.title || ''}`.toLowerCase();
    return /handbag|tote|bag\b|scarf|gift card|accessor|orthotic|insert|slipper/.test(haystack);
  };
  const eligibleHandleSet = (module) => new Set(String(module.dataset.inventoryEligibleHandles || '').split('|').filter(Boolean));
  const formatMoney = (cents, currency) => {
    const amount = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency', currency: currency || 'USD'}).format(amount);
    } catch (error) {
      return `$${amount.toFixed(2)}`;
    }
  };
  const cardMarkup = (product, currency) => {
    const image = product.featured_image || (Array.isArray(product.images) ? product.images[0] : '');
    const compareAt = Number(product.compare_at_price_max || product.compare_at_price || 0);
    const price = Number(product.price || 0);
    return `<article class="sss-pdp-related-card" role="listitem"><a class="sss-pdp-related-card__link" href="${escapeHtml(product.url || `/products/${product.handle}`)}" aria-label="View ${escapeHtml(product.title)}"><div class="sss-pdp-related-card__media">${image ? `<img class="sss-pdp-related-card__image" src="${escapeHtml(image)}" loading="lazy" alt="${escapeHtml(product.title)}">` : ''}</div><div class="sss-pdp-related-card__copy">${product.vendor ? `<p class="sss-pdp-related-card__vendor">${escapeHtml(product.vendor)}</p>` : ''}<h3 class="sss-pdp-related-card__title">${escapeHtml(product.title)}</h3><div class="sss-pdp-related-card__price">${formatMoney(price, currency)}${compareAt > price ? `<s>${formatMoney(compareAt, currency)}</s>` : ''}</div></div></a></article>`;
  };

  const chooseRecommendations = (module, products) => {
    const sourceType = normalize(module.dataset.productType);
    const sourceVendor = normalize(module.dataset.productVendor);
    const sourcePrice = Number(module.dataset.productPrice || 0);
    const allowedHandles = eligibleHandleSet(module);
    const sourceProductId = String(module.dataset.productId || '');
    const eligible = products.filter((item) => item && item.available && allowedHandles.has(item.handle) && String(item.id || '') !== sourceProductId && !isAccessory(item));
    const selected = [];
    const seen = new Set();
    const addFrom = (items) => {
      for (const item of items) {
        if (selected.length >= 2) break;
        if (seen.has(item.id)) continue;
        selected.push(item);
        seen.add(item.id);
      }
    };
    addFrom(eligible.filter((item) => normalize(item.type) === sourceType && (!sourcePrice || (Number(item.price) >= sourcePrice * 0.7 && Number(item.price) <= sourcePrice * 1.3))));
    addFrom(eligible.filter((item) => normalize(item.type) === sourceType));
    addFrom(eligible.filter((item) => normalize(item.vendor) === sourceVendor));
    addFrom(eligible);
    return selected;
  };

  const load = async (module) => {
    if (!module || module.dataset.sssRelatedInitialized === 'true') return;
    module.dataset.sssRelatedInitialized = 'true';
    const track = module.querySelector('[data-sss-related-track]');
    if (!track) return;
    try {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const url = `${root}recommendations/products.json?product_id=${encodeURIComponent(module.dataset.productId)}&limit=10&intent=related`;
      const response = await fetch(url, {headers:{Accept:'application/json'}});
      if (!response.ok) return;
      const data = await response.json();
      const chosen = chooseRecommendations(module, Array.isArray(data.products) ? data.products : []);
      if (chosen.length < 2) return;
      track.innerHTML = chosen.map((item) => cardMarkup(item, module.dataset.currency)).join('');
      module.dataset.recommendationSource = 'shopify-related-inventory-qualified';
    } catch (error) {
      /* Keep the server-rendered inventory-qualified similarity fallback if Shopify recommendations are unavailable. */
    }
  };

  const init = (scope = document) => {
    const modules = scope.querySelectorAll ? scope.querySelectorAll('[data-sss-related-module]') : [];
    modules.forEach((module) => {
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          if (!entries[0].isIntersecting) return;
          observer.disconnect();
          load(module);
        }, {rootMargin:'0px 0px 240px 0px'});
        observer.observe(module);
      } else {
        load(module);
      }
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();